import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const ActionButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  border: 0;
  outline: none;
  background: transparent;
  height: ${theme.spacing['2xm']};

  border-radius: ${theme.shapes.borderRadius.sm};
  font-family: ${theme.typography.family.bold};
  font-weight: ${theme.typography.weight.lg};
  color: ${theme.colors.neutral.white};
  gap: ${theme.spacing.xs};
`
export const ReturnButton = styled.button`
  border: none;
  outline: none;
  margin-right: ${theme.spacing.xm};
  width: 30px;
  height: 30px;
  background-color: transparent;
`
export const ApprovalStatus = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin-left: ${theme.spacing.xs};

  svg {
    path {
      fill: ${theme.colors.primary.main};
    }
  }
`

export const ApproveButton = styled(ActionButton)`
  width: 100%;
  background: ${theme.colors.alert.success.dark};
  :disabled {
    background: ${theme.colors.neutral.lighthover};
    cursor: not-allowed;
  }
`

export const RejectButton = styled(ActionButton)`
  width: 100%;
  background: ${theme.colors.alert.danger.dark};
  :disabled {
    background: ${theme.colors.neutral.lighthover};
    cursor: not-allowed;
  }
`

export const InfoButton = styled(ActionButton)`
  width: 100%;
  background: ${theme.colors.primary.main};
  :disabled {
    background: ${theme.colors.neutral.lighthover};
    cursor: not-allowed;
  }
`

export const BigWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 80%;
  max-width: 1150px;
  white-space: pre-line;
  gap: ${theme.typography.sizes.sm};
`

export const TabsWrapper = styled(BigWrapper)`
  #action-tabs-wrap {
    margin-bottom: 0;
    padding: 0;
    width: 100%;
  }
`

export const TableWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  gap: ${theme.typography.sizes.sm};
`

export const SmallWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 30%;
  max-width: 250px;
  white-space: pre-line;
  gap: ${theme.typography.sizes.sm};
`
export const RowWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  gap: ${theme.spacing.xm};
  width: 100%;
`

export const PaginationWrapper = styled(RowWrapper)`
  align-items: flex-end;
`
interface EllipsisBoxProps {
  maxWidth?: number
}
export const EllipsisBox = styled.div<EllipsisBoxProps>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: ${({ maxWidth }) => `${maxWidth}px` || '100%'};
`
export const SmallRowWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${theme.spacing.xs};
  width: 100%;
`
export const FieldWrapper = styled('div')`
  width: 100%;
`

export const EmptySize = styled.div`
  opacity: 0.2;
`
export const Flex = styled.div`
  width: 65px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`
export const DataItem = styled.div`
  display: flex;
  flex-direction: column;
`
export const Title = styled.h4`
  margin: 0;
  font-family: ${theme.typography.family.bold};
  font-weight: ${theme.typography.weight.xl};
  line-height: ${theme.typography.lineHeight.md};
  color: ${theme.colors.neutral.black};
  font-size: ${theme.typography.sizes['2md']};
`
export const SubTitle = styled.h4`
  margin: 0;
  font-weight: ${theme.typography.weight.xsm};
  line-height: ${theme.typography.lineHeight.md};
  color: ${theme.colors.neutral.light};
  font-size: ${theme.typography.sizes.sm};
`
export const TitleBox = styled.div`
  display: block;
  width: 100%;
  padding: 10px 0;
  border-bottom: ${`${theme.shapes.borderWidth.thin} ${theme.colors.neutral.lighthover}`};
`
export const DataTitle = styled.span`
  display: block;
  font-weight: ${theme.typography.weight.lg};
  font-size: ${theme.typography.sizes.xs};
  color: ${theme.colors.neutral.medium};
`
export const DataValue = styled.span`
  display: block;
  font-weight: ${theme.typography.weight.xsm};
  font-size: ${theme.typography.sizes.xs};
  color: ${theme.colors.neutral.medium};
`

export const DataDescription = styled(DataValue)`
  overflow: auto;
  max-height: 120px;
`

export const SummaryWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: auto;
`

export const TotalizerWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
`

export const TotalizerContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xm};
  padding: ${theme.spacing.sm};
  background-color: ${theme.colors.alert.info.ligther};
  border-radius: 6px;
`

export const TotalizerItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xs};

  p {
    color: ${theme.colors.primary.main} !important;
  }
  span {
    font-size: ${theme.typography.sizes.xs} !important;
    color: ${theme.colors.neutral.high} !important;
  }
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const WarningText = styled.strong`
  color: ${theme.colors.alert.warning.darker};
  font-weight: ${theme.typography.weight.lg};
`
